import { DateTime } from 'luxon';

export const NOW = DateTime.utc();

export const DEFAULT_START_DATE = NOW.minus({ months: 6 }).startOf('month');
export const DEFAULT_END_DATE = NOW.endOf('month');

export enum DashboardPalette {
  green400 = '#5CD633',
  green350 = '#71e848',
  green300 = 'rgb(149 244 129)',
  green250 = '#b3f19e',
  green200 = '#d2f6c7',
  blue200 = '#8B91CA',
  // https://chir.ag/projects/name-that-color/#455EE0
  blue400 = '#3944A5',
  grey = '#DCE6F4',
  // Graduated periwinkle-grey scale, lightest → darkest
  grey50 = '#F6F8FC',
  grey100 = '#EDF1F9',
  grey150 = '#DCE6F4',
  grey200 = '#C7D3E8',
  grey250 = '#B2C0DC',
  grey300 = '#9DADD0',
  grey350 = '#889AC4',
  grey400 = '#7387B8',
  slate50 = '#F0F0F5',
  black = '#000000',
  // https://chir.ag/projects/name-that-color/#C9CEE8
  lightPeriwinkleGrey = '#c9cee84d',
}
